import { render } from "./TrasmittanzaPosizione.vue?vue&type=template&id=329e78ef&scoped=true"
import script from "./TrasmittanzaPosizione.vue?vue&type=script&lang=js"
export * from "./TrasmittanzaPosizione.vue?vue&type=script&lang=js"

import "./TrasmittanzaPosizione.vue?vue&type=style&index=0&id=329e78ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329e78ef"]])

export default __exports__